import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("oxc-resolver");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const sync = _m["sync"];
export const ModuleType = _m["ModuleType"];
export const EnforceExtension = _m["EnforceExtension"];
export const ResolverFactory = _m["ResolverFactory"];
export const ResolveDtsTask = _m["ResolveDtsTask"];
export const ResolveTask = _m["ResolveTask"];
export const ResolveFileTask = _m["ResolveFileTask"];